import { Button, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import DeleteDocumentModal from './modal/DeleteDocumentModal';
import EditAddDocumentModal from './modal/EditAddDocumentModal';

const DocumentActions = ({ documentId, refetchDocuments, docId }: any) => {
  const [editDocumentId, setEditDocumentId] = useState<string | null>(null);
  const [deleteDocumentId, setDeleteDocumentId] = useState<string | null>(null);

  return (
    <>
      {!!editDocumentId && (
        <EditAddDocumentModal
          docId={docId}
          documentId={editDocumentId}
          onClose={() => {
            setEditDocumentId(null);
          }}
        />
      )}

      {!!deleteDocumentId && (
        <DeleteDocumentModal
          openModal={true}
          docId={docId}
          onClose={() => {
            setDeleteDocumentId(null);
          }}
          documentId={deleteDocumentId}
        />
      )}

      <Stack direction="row" spacing={3}>
        <Button variant="contained" onClick={() => setEditDocumentId(documentId)}>
          <Typography>
            <FormattedMessage defaultMessage="Edit" />
          </Typography>
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            console.log('delete clicked ', documentId);
            setDeleteDocumentId(documentId);
          }}
        >
          <Typography>
            <FormattedMessage defaultMessage="Delete" />
          </Typography>
        </Button>
      </Stack>
    </>
  );
};

export default DocumentActions;
